import * as React from 'react'
import { SVGProps } from 'react'
const Avalanche = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={30}
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path fill="#fff" d="M24.252 5.146H5.729v16.836h18.523V5.146Z" />
      <path
        fill="#E84142"
        fillRule="evenodd"
        d="M29.99 15c0 8.273-6.711 14.98-14.99 14.98S.01 23.273.01 15 6.72.02 15 .02 29.99 6.727 29.99 15Zm-19.238 5.961h-2.91c-.61 0-.912 0-1.096-.117a.739.739 0 0 1-.336-.578c-.01-.217.14-.482.442-1.012L14.035 6.6c.306-.537.46-.806.656-.905a.742.742 0 0 1 .67 0c.195.1.35.368.655.905l1.477 2.576.008.013c.33.577.497.869.57 1.176.081.335.081.688 0 1.023-.073.309-.239.603-.574 1.189l-3.773 6.665-.01.017c-.332.581-.5.876-.734 1.098-.254.243-.56.42-.895.519-.306.084-.648.084-1.333.084Zm7.347 0h4.168c.615 0 .924 0 1.109-.12a.737.737 0 0 0 .335-.582c.01-.21-.137-.465-.427-.964l-.03-.052-2.088-3.57-.024-.04c-.293-.496-.441-.746-.631-.843a.733.733 0 0 0-.667 0c-.191.1-.346.36-.652.887l-2.08 3.57-.007.012c-.305.525-.457.788-.446 1.003a.746.746 0 0 0 .335.582c.18.117.49.117 1.105.117Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h30v30H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default Avalanche
